import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { NotificationService } from 'app/_services/notification.service';
import { Globals } from 'app/_globals';
import { ProductsService } from '../../../_services/products.service';
import { ObjectFilterPipe } from '../../../_pipes/object-filter.pipe';
import { CategoryService } from '../../../_services/category.service';
import { KioskCategoryService } from '../../../_services/kiosk-category.service';
import { TreeNode } from 'primeng/api';
import { CookieService } from 'ngx-cookie-service';

@Component({
    selector: 'app-product-details',
    templateUrl: './product-details.component.html',
    styleUrls: ['./product-details.component.css']
})
export class ProductDetailsComponent implements OnInit {

    tabitems: any = [];

    productId: any;
    selectedProduct: any;
    productDetailsForm: FormGroup;

    changeCategoryModal = false;
    changeKioskCategoryModal = false;
    cookieStore: any;
    storeId: any;

    role: any;
    routeRole: any;

    displayCategories: TreeNode[] = [];
    categories: any[] = [];
    selectedCategory = { label: 'No Category Selected', id: null, name: null, data: { id: null } };

    displayKioskCategories: TreeNode[] = [];
    kioskCategories: any[] = [];
    selectedKioskCategory = { label: 'No Kiosk Category Selected', id: null, data: { id: null } };

    constructor(
        public fb: FormBuilder,
        public activatedRoute: ActivatedRoute,
        public loader: LoadingBarService,
        public notificationService: NotificationService,
        public globals: Globals,
        public _productsService: ProductsService,
        public objectFilter: ObjectFilterPipe,
        public _categoryService: CategoryService,
        public _kioskCategoryService: KioskCategoryService,
        public cookieService: CookieService,
        public router: Router
    ) {
        // Get Patient id from params
        this.activatedRoute.params.subscribe((params: Params) => {
            this.productId = params.id;
        });

        // Handle Store Cookies
        const hasCurrentStore = cookieService.check('currentStore');
        if (hasCurrentStore) {
            this.cookieStore = JSON.parse(cookieService.get('currentStore'));
            this.storeId = this.cookieStore.id;
        } else {
            this.router.navigate(['/' + this.globals.user.routeRole + '/select-store']);
        }

        this.role = globals.user.role;
        this.routeRole = globals.user.routeRole;

        this.tabitems = [
            { path: '/' + this.routeRole + '/products/', title: 'All Products', class: 'back-link' },
            { path: '/' + this.routeRole + '/products/' + this.productId + '/details', title: 'Details' },
            { path: '/' + this.routeRole + '/products/' + this.productId + '/images', title: 'Images' },
            { path: '/' + this.routeRole + '/products/' + this.productId + '/nutrition', title: 'Nutrition' },
            { path: '/' + this.routeRole + '/products/' + this.productId + '/ingredients-allergens', title: 'Ingredients & Allergens' }
        ];

        this.productDetailsForm = fb.group({
            description: new FormControl(),
            discontinued: new FormControl(),
            displayName: new FormControl(),
            ean: new FormControl(),
            categoryId: new FormControl(),
            categoryKioskId: new FormControl(),
            itemCategory: new FormControl(),
            itemCategoryKiosk: new FormControl(),
            managed: new FormControl(),
            name: new FormControl(),
            price: new FormControl(),
            productCode: new FormControl(),
            sortOrder: new FormControl(),
            allergensApiProductId: new FormControl(),
            enabled: new FormControl(),
            ageRestriction: new FormControl(),
        });

    }

    ngOnInit() {
        this.getProduct(this.productId);
        this.getAllCategories();
        this.getAllKioskCategories();
    }

    // Get Product by id
    public getProduct(id) {
        this._productsService.getProductById(id)
            .subscribe((data: any) => {
                console.log('Indi Product ', data);
                this.selectedProduct = data;
                this.assignFormValues();
            })
    }

    // Assign values to form
    public assignFormValues() {
        this.productDetailsForm.patchValue({
            description: this.selectedProduct.description,
            discontinued: this.selectedProduct.discontinued,
            displayName: this.selectedProduct.displayName,
            ageRestriction: this.selectedProduct.ageRestriction,
            ean: this.selectedProduct.ean,
            managed: this.selectedProduct.managed,
            name: this.selectedProduct.name,
            price: this.selectedProduct.price,
            productCode: this.selectedProduct.productCode,
            sortOrder: this.selectedProduct.sortOrder,
            allergensApiProductId: this.selectedProduct.allergensApiProductId,
            enabled: this.selectedProduct.enabled
        })
        if (this.selectedProduct.itemCategory !== null) {
            this.productDetailsForm.patchValue({
                itemCategory: this.selectedProduct.itemCategory.name,
                categoryId: this.selectedProduct.itemCategory.id,
            });
        } else {
            this.productDetailsForm.patchValue({
                itemCategory: null,
                categoryId: null
            })
        }
        if (this.selectedProduct.itemCategoryKiosk !== null) {
            this.productDetailsForm.patchValue({
                itemCategoryKiosk: this.selectedProduct.itemCategoryKiosk.name,
                categoryKioskId: this.selectedProduct.itemCategoryKiosk.id,
            });
        } else {
            this.productDetailsForm.patchValue({
                itemCategoryKiosk: null,
                categoryKioskId: null
            })
        }
    }

    // Product Details Form Submit
    public onProductDetailsFormSubmit() {
        const values = this.productDetailsForm.value;
        const body = {
            id: this.selectedProduct.id,
            description: values.description,
            discontinued: values.discontinued,
            displayName: values.displayName,
            ean: values.ean,
            categoryId: values.categoryId,
            categoryKioskId: values.categoryKioskId,
            managed: values.managed,
            name: values.name,
            price: values.price,
            productCode: values.productCode,
            sortOrder: values.sortOrder,
            allergensApiProductId: values.allergensApiProductId,
            enabled: values.enabled,
            ageRestriction: values.ageRestriction
        };
        this._productsService.editProduct(body)
            .subscribe((data: any) => {
                this.getProduct(this.selectedProduct.id);
                this.notificationService.notify(
                    'success',
                    'Product Updated',
                    'Product has successfully been updated',
                    'top',
                    'right');
            });
    }

    // CHANGING CATEGORIES FUNCTIONS
    public getAllCategories() {
        this.displayCategories = [];
        this._categoryService.getItemCategoriesByStoreId(this.storeId)
            .subscribe((data: any) => {
                this.categories = data;
                this.filterRootItemCategories(null);
            })
    }

    public getAllKioskCategories() {
        this.displayKioskCategories = [];
        this._kioskCategoryService.getItemKioskCategoriesByStoreId(this.storeId)
            .subscribe((data: any) => {
                this.kioskCategories = data;
                this.filterRootItemKioskCategories(null);
            })
    }

    public populateTreeMenu(array) {
        const filteredArray = array;
        filteredArray.forEach(element => {
            // console.log(element);
            const treeNodeObject = {
                label: element.name,
                data: element,
                id: element.id,
                parent: element.parentItemCategoryId,
                expandedIcon: 'fa fa-folder-open',
                collapsedIcon: 'fa fa-folder',
                leaf: false
            };
            this.displayCategories.push(treeNodeObject);
        });
    }

    public populateKioskTreeMenu(array) {
        const filteredArray = array;
        filteredArray.forEach(element => {
            // (element);
            const treeNodeObject = {
                label: element.name,
                data: element,
                id: element.id,
                parent: element.parentItemCategoryId,
                expandedIcon: 'fa fa-folder-open',
                collapsedIcon: 'fa fa-folder',
                leaf: false
            };
            this.displayKioskCategories.push(treeNodeObject);
        });
    }

    public filterRootItemCategories(categoryId) {
        const catId = categoryId;
        const filteredCats = this.objectFilter.transform(this.categories, 'parentItemCategoryId', catId);
        this.populateTreeMenu(filteredCats);
    }

    public filterRootItemKioskCategories(kioskCategoryId) {
        const catId = kioskCategoryId;
        const filteredCats = this.objectFilter.transform(this.kioskCategories, 'parentItemCategoryId', catId);
        this.populateKioskTreeMenu(filteredCats);
    }

    public loadNode(event) {
        if (event.node) {
            const parentId = event.node.data.id;
            const children = this.objectFilter.transform(this.categories, 'parentItemCategoryId', parentId);
            children.forEach(element => {
                element.label = element.name;
                element.data = element;
                element.parent = element.parentItemCategoryId;
                element.expandedIcon = 'fa fa-folder-open';
                element.collapsedIcon = 'fa fa-folder';
                element.leaf = false;
            });
            event.node.children = children;
        }
    }

    public loadNodeKiosk(event) {
        if (event.node) {
            const parentId = event.node.data.id;
            const children = this.objectFilter.transform(this.kioskCategories, 'parentItemCategoryId', parentId);
            children.forEach(element => {
                element.label = element.name;
                element.data = element;
                element.parent = element.parentItemCategoryId;
                element.expandedIcon = 'fa fa-folder-open';
                element.collapsedIcon = 'fa fa-folder';
                element.leaf = false;
            });
            event.node.children = children;
        }
    }

    public nodeSelect(event) {
        this.selectedCategory.label = event.node.data.name;
        this.selectedCategory.id = event.node.data.id;
        this.selectedCategory.data = event.node.data;
    }

    public nodeSelectKiosk(event) {
        this.selectedKioskCategory.label = event.node.data.name;
        this.selectedKioskCategory.id = event.node.data.id;
        this.selectedKioskCategory.data = event.node.data;
    }

    public openChangeCategoryModal() {
        this.changeCategoryModal = !this.changeCategoryModal;
    }

    public openChangeKioskCategoryModal() {
        this.changeKioskCategoryModal = !this.changeKioskCategoryModal;
    }

    public confirmCategoryChange() {
        this.productDetailsForm.patchValue({
            categoryId: this.selectedCategory.id,
            itemCategory: this.selectedCategory.label
        })
        this.openChangeCategoryModal();
    }

    public confirmKioskCategoryChange() {
        this.productDetailsForm.patchValue({
            categoryKioskId: this.selectedKioskCategory.id,
            itemCategoryKiosk: this.selectedKioskCategory.label
        })
        this.openChangeKioskCategoryModal();
    }
}



// WEBPACK FOOTER //
// ./src/app/products/single-product/details/product-details.component.ts